import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectFormalQuote } from 'formal_quote/selectors';
import { Modal, Button } from 'react-bootstrap';
import { dismissSuccessModal } from 'formal_quote/slice';

const SuccessModal = () => {
  const { successModal } = useSelector(selectFormalQuote);
  const dispatch = useDispatch();

  const onDismiss = () => {
    dispatch(dismissSuccessModal());
  };

  const onGoHome = () => {
    dispatch(dismissSuccessModal());
    if (typeof window !== 'undefined') {
      // eslint-disable-next-line no-undef
      window.location.href = '/';
    }
  };

  return (
    <Modal
      show={successModal}
      onHide={onDismiss}
      centered
      className="formal-quote-success-modal"
    >
      <Modal.Header closeButton className="border-0 pb-0">
        <Modal.Title className="sr-only">Success</Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center px-4 pb-4">
        <div className="mb-3">
          <img
            src={Spree.image_assets.success}
            alt="Success"
            width="48"
            height="48"
          />
        </div>

        <h4 className="font-weight-bold text-dark mb-2">
          Software Product Formal Quote Request Received!
        </h4>

        <p className="text-muted mb-4">
          The Pentalogix Sales team will be sending an email with your quote
          within the next few hours.
        </p>

        <div className="d-flex flex-column flex-sm-row justify-content-center">
          <Button variant="outline" className="mr-2" onClick={onDismiss}>
            Dismiss
          </Button>
          <Button variant="dark" onClick={onGoHome}>
            Homepage
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default SuccessModal;
